export class PromotionalOffer {
    constructor(productDiscount, paymentDiscount) {
        this.productDiscount = productDiscount;
        this.paymentDiscount = paymentDiscount;
    }
}
//# sourceMappingURL=PromotionalOffer.js.map